var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignCourseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.35938,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3438 17.2656C25.5469 17.2656 25.75 17.4688 25.75 17.6719V18.4844C25.75 18.7129 25.5469 18.8906 25.3438 18.8906H23.7188V20.5156C23.7188 20.7441 23.5156 20.9219 23.3125 20.9219H22.5C22.2715 20.9219 22.0938 20.7441 22.0938 20.5156V18.8906H20.4688C20.2402 18.8906 20.0625 18.7129 20.0625 18.4844V17.6719C20.0625 17.4688 20.2402 17.2656 20.4688 17.2656H22.0938V15.6406C22.0938 15.4375 22.2715 15.2344 22.5 15.2344H23.3125C23.5156 15.2344 23.7188 15.4375 23.7188 15.6406V17.2656H25.3438ZM15.1875 18.4844C13.3848 18.4844 11.9375 17.0371 11.9375 15.2344C11.9375 13.457 13.3848 11.9844 15.1875 11.9844C16.9648 11.9844 18.4375 13.457 18.4375 15.2344C18.4375 17.0371 16.9648 18.4844 15.1875 18.4844ZM17.4473 19.2969C19.3262 19.2969 20.875 20.8457 20.875 22.7246V23.7656C20.875 24.4512 20.3164 24.9844 19.6562 24.9844H10.7188C10.0332 24.9844 9.5 24.4512 9.5 23.7656V22.7246C9.5 20.8457 11.0234 19.2969 12.9023 19.2969H13.334C13.8926 19.5762 14.5273 19.7031 15.1875 19.7031C15.8477 19.7031 16.457 19.5762 17.0156 19.2969H17.4473Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignCourseButton);
export default __webpack_public_path__ + "static/media/AssignCourseButton.e0b580df750de80627d682251369ded1.svg";
export { ForwardRef as ReactComponent };